import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "@chatable/ui-components";
import { queryClient } from "./api/queryClient";
import { AuthProvider } from "./contexts/AuthContext";
import { router } from "./router";
import { trpc, trpcClient } from "./api/trpc";
import { AuthBootstrapGate } from "./components/AuthBootstrapGate";

function App() {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <AuthBootstrapGate>
              <RouterProvider router={router} />
            </AuthBootstrapGate>
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </trpc.Provider>
  );
}

export default App;

// Deployment trigger Thu Sep 19 18:52:00 EEST 2025 - Google OAuth fix
